import { icon, node } from "~/util/dom";

interface ITooltipCloseProps {
	className?: string;
	arrow?: "none" | "down";
	onClose?: () => void;
}

export default class TooltipClose {
	_dom: {
		container: HTMLDivElement;
		closeBtn: HTMLButtonElement;
	};

	_options: ITooltipCloseProps;

	constructor(options: ITooltipCloseProps) {
		this._options = {
			arrow: "none",
			className: "",
			onClose: () => {},
			...options,
		};
		this._dom = {
			container: node("div", { className: "tooltipClose" }),
			closeBtn: node("button", { className: "tooltipClose__closeBtn", type: "button" }),
		};
		this._dom.closeBtn.append(icon("close"));
		this._dom.closeBtn.addEventListener("click", () => {
			this._options.onClose();
		});
		this._dom.container.append(this._dom.closeBtn);

		if (this._options.className) {
			const classes = this._options.className.split(" ");

			classes.forEach(className => this._dom.container.classList.add(className));
		}

		if (this._options.arrow !== "none") {
			this._dom.container.classList.add(`arrow-${this._options.arrow}`);
		}
	}

	get container() {
		return this._dom.container;
	}

	close() {
		this._options.onClose();
	}
}
